module.exports = __webpack_public_path__ + "media/images/hero/glyph-a4-832959623ddd9d1076e7358e5cbac202.svg";